export const PredictedData = [
  { year: 1961, value: 0.0 },
  { year: 1962, value: 0.0 },
  { year: 1963, value: 0.0 },
  { year: 1964, value: 0.0 },
  { year: 1965, value: 0.0 },
  { year: 1966, value: 0.0 },
  { year: 1967, value: 0.0 },
  { year: 1968, value: 0.0 },
  { year: 1969, value: 0.0 },
  { year: 1970, value: 0.0 },
  { year: 1971, value: 0.0 },
  { year: 1972, value: 0.0 },
  { year: 1973, value: 0.0 },
  { year: 1974, value: 0.0 },
  { year: 1975, value: 0.0 },
  { year: 1976, value: 0.0 },
  { year: 1977, value: 0.0 },
  { year: 1978, value: 0.0 },
  { year: 1979, value: 0.0 },
  { year: 1980, value: 0.0 },
  { year: 1981, value: 0.0 },
  { year: 1982, value: 0.0 },
  { year: 1983, value: 0.0 },
  { year: 1984, value: 0.0 },
  { year: 1985, value: 0.0 },
  { year: 1986, value: 0.0 },
  { year: 1987, value: 0.0 },
  { year: 1988, value: 0.0 },
  { year: 1989, value: 0.0 },
  { year: 1990, value: 938.8 },
  { year: 1991, value: 1182.25 },
  { year: 1992, value: 1234.16 },
  { year: 1993, value: 1409.8 },
  { year: 1994, value: 1744.5 },
  { year: 1995, value: 1895.7 },
  { year: 1996, value: 1959.1 },
  { year: 1997, value: 2191.37 },
  { year: 1998, value: 2315.7 },
  { year: 1999, value: 3123.7 },
  { year: 2000, value: 3221.0 },
  { year: 2001, value: 3464.6 },
  { year: 2002, value: 2786.7 },
  { year: 2003, value: 3021.8 },
  { year: 2004, value: 2809.6 },
  { year: 2005, value: 3188.6 },
  { year: 2006, value: 2616.1 },
  { year: 2007, value: 2693.6 },
  { year: 2008, value: 2994.9 },
  { year: 2009, value: 3882.8 },
  { year: 2010, value: 4640.9 },
  { year: 2011, value: 5199.2 },
  { year: 2012, value: 5997.8 },
  { year: 2013, value: 6087.8 },
  { year: 2014, value: 7132.2 },
  { year: 2015, value: 7186.2 },
  { year: 2016, value: 10735.7 },
  { year: 2017, value: 11918.9 },
  { year: 2018, value: 13081.2 },
  { year: 2019, value: 14223.0 },
  { year: 2020, value: 15344.6 },
];

export const prediction = [
  { year: 1961, value: 0.0 },
  { year: 1962, value: 0.0 },
  { year: 1963, value: 0.0 },
  { year: 1964, value: 0.0 },
  { year: 1965, value: 0.0 },
  { year: 1966, value: 0.0 },
  { year: 1967, value: 0.0 },
  { year: 1968, value: 0.0 },
  { year: 1969, value: 0.0 },
  { year: 1970, value: 0.0 },
  { year: 1971, value: 0.0 },
  { year: 1972, value: 0.0 },
  { year: 1973, value: 0.0 },
  { year: 1974, value: 0.0 },
  { year: 1975, value: 0.0 },
  { year: 1976, value: 0.0 },
  { year: 1977, value: 0.0 },
  { year: 1978, value: 0.0 },
  { year: 1979, value: 0.0 },
  { year: 1980, value: 0.0 },
  { year: 1981, value: 0.0 },
  { year: 1982, value: 0.0 },
  { year: 1983, value: 0.0 },
  { year: 1984, value: 0.0 },
  { year: 1985, value: 0.0 },
  { year: 1986, value: 0.0 },
  { year: 1987, value: 0.0 },
  { year: 1988, value: 0.0 },
  { year: 1989, value: 0.0 },
  { year: 1990, value: 938.8 },
  { year: 1991, value: 1182.25 },
  { year: 1992, value: 1234.16 },
  { year: 1993, value: 1409.8 },
  { year: 1994, value: 1744.5 },
  { year: 1995, value: 1895.7 },
  { year: 1996, value: 1959.1 },
  { year: 1997, value: 2191.37 },
  { year: 1998, value: 2315.7 },
  { year: 1999, value: 3123.7 },
  { year: 2000, value: 3221.0 },
  { year: 2001, value: 3464.6 },
  { year: 2002, value: 2786.7 },
  { year: 2003, value: 3021.8 },
  { year: 2004, value: 2809.6 },
  { year: 2005, value: 3188.6 },
  { year: 2006, value: 2616.1 },
  { year: 2007, value: 2693.6 },
  { year: 2008, value: 2994.9 },
  { year: 2009, value: 3882.8 },
  { year: 2010, value: 4640.9 },
  { year: 2011, value: 5199.2 },
  { year: 2012, value: 5997.8 },
  { year: 2013, value: 6087.8 },
  { year: 2014, value: 7132.2 },
  { year: 2015, value: 7186.2 },
  { year: 2016, value: 10735.7 },
  { year: 2017, value: 11417.8 },
  { year: 2018, value: 14163.5 },
  { year: 2019, value: 13094.5 },
  { year: 2020, value: 16017.4 },
  { year: 2021, value: 15503.6 },
  { year: 2022, value: 18877.4 },
  { year: 2023, value: 18095.5 },
  { year: 2024, value: 21104.7 },
  { year: 2025, value: 20328.4 },
];
